// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3mV8F","name":"ConsentHeader_name__3mkSI","birthday":"ConsentHeader_birthday__WADtf","skeleton":"ConsentHeader_skeleton__3SG4U"};